export default "__VITE_ASSET__BxMLO0BV__"